import React, { useContext, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { AppContext } from '../../App';
import LabDataLayout, { useLabDataFilters } from '../../components/LabData/LabDataLayout';
import BudgetLinesTable from '../../components/LabData/BudgetLinesTable';
import UnassignedSpendCard from '../../components/LabData/UnassignedSpendCard';
import { getBudgetLinesBurn } from '../../clients/lab_data_client';
import { showToast } from '../../config_and_helpers/helpers';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'BudgetLinesPage';

/**
 * Lab Data burn list — analytics only. Budget CRUD lives under Procure → Budgets.
 */
const BudgetLinesContent = () => {
  const { token } = useContext(AppContext);
  const filters = useLabDataFilters();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [unassigned, setUnassigned] = useState(null);

  useEffect(() => {
    if (!token || !filters) return;
    setLoading(true);
    logInfo(LOG_CONTEXT, 'load budget burn', filters);
    getBudgetLinesBurn(token, { from: filters.from, to: filters.to }).then(res => {
      setLoading(false);
      if (!res.success) {
        showToast(res.messages?.[0] || 'Failed to load budgets', 'error', 'top-right', 5000);
        return;
      }
      const payload = res.data?.data ?? res.data ?? {};
      setRows(payload.budget_lines ?? []);
      setUnassigned(payload.unassigned ?? null);
    });
  }, [token, filters?.from, filters?.to, filters]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading budget burn</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <BudgetLinesTable
        rows={rows}
        dateFrom={filters?.from}
        dateTo={filters?.to}
      />
      <UnassignedSpendCard unassigned={unassigned} />
    </>
  );
};

/**
 * Budget burn analytics page. Create and edit stay on Procure → Budgets.
 */
const BudgetLinesPage = () => (
  <LabDataLayout title="Lab data — Budget burn">
    <BudgetLinesContent />
  </LabDataLayout>
);

export default BudgetLinesPage;
